import React, { useState, useEffect } from "react";

import {FormControl, Accordion, AccordionDetails, AccordionSummary, TextField, IconButton, FormGroup, Checkbox, FormControlLabel, RadioGroup, Radio, Autocomplete, FormLabel, Switch} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import config from '../../../hoa-config';
import MultilineRegulationsTextArea from '../../../Container/multiline-regulations-text-area'
import useFieldDisabled from "../../../hooks/useFieldDisabled";
import EditCancelConfirmationModal from "../../../shared-components/edit-cancel-confirmation";


interface HoaLandScapingFormProps {
    handleChange : any;
    values: any;
}

export default function HoaLandScapingForm(props: HoaLandScapingFormProps) {
    const {handleChange, values} = props;
    const { isLandscapingFiledDisabled, isGrassTypeRegulationDisabled } = useFieldDisabled();
    const [grassOptions, setGrassOptions] = useState(config.grassTypes);
    const [selectedGrass, setSelectedGrass] = useState('');
    const stateList : any = {
        assesmentFrequency : '',
        timeline : '',
        acceptableHeightOfGrass : '',
        grassSize : '',
        typesOfGrass : [],
        grassTrimmingRegulations: '',
        grassTypeRegulations: false,
        allowedTypesOfGrass: [],
        restrictedTypesOfGrass: [],
        markedGrassType: '',
        artificialGrassOnProperty : '',
        restrictedOptions: [],
        canopyHeight : '',
        canopySize : '',
        mandatoryOptions: [],
        grassTypeAdditionalInfo: '',
        regulationsOfAlterationAndPlantingOfTrees: '',
        regulationsOfPruningTrimming: '',
        regulationsOfVegetationObstructingResidents: '',
        regulationsOfMulchReplenishing: '',
        regulationsOfIrrigationMaintenanceAndStainPrevention: '',
        regulationsOfFertilization: '',
    }

    const [state, setState] = useState(stateList);
    const [expanded1, setExpanded1] = useState(false);
    const [expanded2, setExpanded2] = useState(false);
    const [expanded3, setExpanded3] = useState(false);
    const [isWaring, setIsWarning] = useState(false);
    const [fieldInfo, setFieldInfo] = useState({
        field: '',
        key: '',
    });

    useEffect(() => {
        if (values) {
            let tempState = JSON.parse(JSON.stringify(state));
            Object.keys(tempState).map((key) => {
                tempState[key] = values[key] || (Array.isArray(tempState[key]) ? [] : typeof tempState[key] === 'object' ? {} : '');
            })
            setState(tempState);
        }
    }, [values])

    useEffect(()=>{
        const newOptions = grassOptions.filter((option: string)=>{
            return !state.allowedTypesOfGrass.includes(option) && !state.restrictedTypesOfGrass.includes(option);
        })
        setGrassOptions(newOptions);
    }, [state])

    const handleCurrentChange = (value: any, key: string, checkBoxSelectedKey:string = '') => {
        let tempState: any = JSON.parse(JSON.stringify(state));
        if(value == null){
            value = "";
        }
        tempState[key] = value;

        if (key === 'grassTypeRegulations' && value === false) {
            tempState.allowedTypesOfGrass = [];
            tempState.restrictedTypesOfGrass = [];
            setGrassOptions(config.grassTypes);
        }

        if(checkBoxSelectedKey && config.violationRegulations[checkBoxSelectedKey]) {
            tempState[config.violationRegulations[checkBoxSelectedKey]] = '';
        }
        setState(tempState);
        handleChange(tempState, 'landscaping');
    }

    const handleCheckBoxGroup = (checked: boolean, key: string, stateName : string) => {
        let tempValue = state[stateName];
        if(checked && !tempValue.includes(key)){
            tempValue.push(key);
        } else if(!checked && tempValue.includes(key)){
            tempValue = tempValue.filter((value: any) => {return value !== key})
        }
        handleCurrentChange(tempValue, stateName, key);
    }

    const Wheel =(e: any) => {
        e.target.blur();
    }

    const grassOptionReset = (value:any) => {
        const newOptions = grassOptions.filter((option: string)=>{
            return !value.includes(option);
        })
        setGrassOptions(newOptions);
    }

    const handleGrassChange = (value: any, key: string) => {
        let tempState : any = JSON.parse(JSON.stringify(state));
        if(key === 'allowedTypesOfGrass' && value){
            tempState.allowedTypesOfGrass.push(value);
            grassOptionReset(tempState.allowedTypesOfGrass);
            setState(tempState);
            handleChange(tempState, 'landscaping');
            setSelectedGrass('');
            return;
        }
        else if (key === 'restrictedTypesOfGrass' && value) {
            tempState.restrictedTypesOfGrass.push(value);
            grassOptionReset(tempState.restrictedTypesOfGrass);
            setState(tempState);
            handleChange(tempState, 'landscaping');
            setSelectedGrass('');
            return;
        }
    }

    const removeGrass = (grass: string, key: string) => {
        let tempState : any = JSON.parse(JSON.stringify(state));
        tempState[key] = tempState[key].filter((currentGrass:string)=> {return currentGrass !== grass});
        setGrassOptions([...grassOptions,grass])
        setState(tempState);
        handleChange(tempState, 'landscaping');
    }

    const handleConnectedFieldChange = (isChecked: boolean, field: string, key: string, regulation: string) => {
        if (!isChecked && regulation) {
            setFieldInfo({
                field: field,
                key: key,
            });
            setIsWarning(!isWaring);

        } else if (isChecked && !regulation) {
            handleCheckBoxGroup(isChecked, field, key);

        } else {
            handleCheckBoxGroup(isChecked, field, key);
        }
    }

    const unCheckWarningYesClick = () => {
        let tempValue = state[fieldInfo.key];
        if(tempValue.includes(fieldInfo.field)){
            tempValue = tempValue.filter((value: any) => {return value !== fieldInfo.field})
        }
        handleCurrentChange(tempValue, fieldInfo.key, fieldInfo.field);
        setIsWarning(false);
    }

    return (
        <>
            <Accordion
            style={{background: expanded1 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded1(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Grass Trimming
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA"}}>
                    <div style={{width: '100%', display:"flex", flexDirection:"column"}}>
                        <div style={{ display: "flex", flexDirection: "row", marginBottom: "12px" }}>
                            <TextField style={{ width: '30%', marginRight: "20px", height: '64px' }} variant="standard" label="Assessment Frequency" value={state.assesmentFrequency} type='number'
                                onChange={(e) => { handleCurrentChange(e.target.value, "assesmentFrequency") }} onWheel={e => Wheel(e)} InputLabelProps={{ style: { fontSize: "14px" } }}
                                InputProps={{ style: { padding: "7px 0px" } }}
                                disabled={isLandscapingFiledDisabled('assesmentFrequency')}
                            />
                            <Autocomplete
                                ListboxProps={{ style: { maxHeight: "200px"} }}
                                style={{ width: "25%", height:"64px", boxSizing:"border-box"}}
                                disablePortal
                                value={state.timeline ? state.timeline : ''}
                                options={config.timeLines}
                                disabled={isLandscapingFiledDisabled('timeline')}
                                onChange={(e, v) => {
                                    handleCurrentChange(v, "timeline")
                                }}
                                renderInput={(params: any) => <TextField variant="standard" style={{height:"100%"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label="Timeline"/>}
                            />
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", marginBottom: "12px" }}>
                            <TextField style={{ width: "30%", marginRight: "20px", height: '64px' }} variant="standard" label="Acceptable Height Of Grass" value={state.acceptableHeightOfGrass} type='number'
                                onChange={(e) => { handleCurrentChange(e.target.value, "acceptableHeightOfGrass") }} onWheel={e => Wheel(e)} InputLabelProps={{ style: { fontSize: "14px" } }}
                                InputProps={{ style: { padding: "7px 0px" } }} 
                                disabled={isLandscapingFiledDisabled('acceptableHeightOfGrass')}
                            />
                            <Autocomplete
                                ListboxProps={{ style: { maxHeight: "200px"} }}
                                style={{ width: "25%", height:"64px", boxSizing:"border-box"}}
                                disablePortal
                                value={state.grassSize ? state.grassSize : ''}
                                options={config.sizes}
                                disabled={isLandscapingFiledDisabled('grassSize')}
                                onChange={(e, v) => {
                                    handleCurrentChange(v, "grassSize")
                                }}
                                renderInput={(params: any) => <TextField variant="standard" style={{height:"100%"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label="Size"/>}
                            />
                        </div>

                        <MultilineRegulationsTextArea 
                            additionalStyle={{ 
                                padding: "10px 0px",
                                marginRight: "17px",
                                width: "380px" 
                            }}
                            regulationType={'grassTrimmingRegulations'}
                            value={state.grassTrimmingRegulations}
                            handleCurrentChange={handleCurrentChange}
                            disabled={isLandscapingFiledDisabled('grassTrimmingRegulations')}
                        />
                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '30px', marginBottom: '20px' }}>
                            <div style={{ marginRight: '25px' }}>
                                <div className="sub-title-text" style={{ marginBottom: '5px' }}>Grass Type Regulation</div>
                                <div className="helperText">Enabling this will let you define allowed & restricted grass types.</div>
                            </div>
                            <FormControlLabel
                                sx={{ display: 'block' }}
                                control={
                                <Switch
                                    checked={state.grassTypeRegulations}
                                    onChange={(e)=>{handleCurrentChange(e.target.checked, "grassTypeRegulations")}}
                                    name="grassTypeRegulations"
                                    color="primary"
                                    disabled={isGrassTypeRegulationDisabled()}
                                />
                                }
                                label=""
                            />
                        </div>
                        {
                            state.grassTypeRegulations &&
                            <>
                                <div className="sub-title-text-2">Allowed Grass Types</div>
                                <Autocomplete
                                    ListboxProps={{ style: { maxHeight: "200px"} }}
                                    style={{ width: "80%", height:"62px", boxSizing:"border-box"}}
                                    disablePortal
                                    value={selectedGrass || ''}
                                    options={grassOptions}
                                    onChange={(e, v) => {
                                        handleGrassChange(v, "allowedTypesOfGrass")
                                    }}
                                    renderInput={(params: any) => <TextField variant="standard" style={{height:"100%"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label="Write name here to add"/>}
                                    // disabled={state.markedGrassType === "N/A"}
                                    disabled={isLandscapingFiledDisabled('allowedTypesOfGrass')}
                                />
                                <div style={{marginTop : '24px', display:"flex", flexWrap:"wrap"}}>
                                {
                                    state.allowedTypesOfGrass.length > 0 &&
                                    state.allowedTypesOfGrass.map((grass: string, index: number)=>{
                                        for(const key of config.grassTypes){
                                            if(key === grass){
                                                return(
                                                    <div className="amenityIconBox" key={key+'-'+index}>
                                                        {/* {React.createElement(config.grassTypes[key], {style:{margin: "3px"}, color:"primary"})} */}
                                                        <span style={{margin:"0px 5px"}}>{key}</span>
                                                        <IconButton 
                                                            onClick={()=>{removeGrass(grass, "allowedTypesOfGrass")}} 
                                                            style={{padding:"0px"}}
                                                            disabled={isLandscapingFiledDisabled('allowedTypesOfGrass')}
                                                        >
                                                            <CloseIcon/>
                                                        </IconButton>
                                                    </div>
                                                )
                                            }
                                        }
                                    })
                                }
                                </div>
                                <div className="sub-title-text-2" style={{ marginTop: '20px' }}>Restricted Grass Types</div>
                                <Autocomplete
                                    ListboxProps={{ style: { maxHeight: "200px"} }}
                                    style={{ width: "80%", height:"62px", boxSizing:"border-box"}}
                                    disablePortal
                                    value={selectedGrass || ''}
                                    options={grassOptions}
                                    onChange={(e, v) => {
                                        handleGrassChange(v, "restrictedTypesOfGrass")
                                    }}
                                    renderInput={(params: any) => <TextField variant="standard" style={{height:"100%"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label="Write name here to add"/>}
                                    // disabled={state.markedGrassType === "N/A"}
                                    disabled={isLandscapingFiledDisabled('restrictedTypesOfGrass')}
                                />
                                <div style={{marginTop : '24px', display:"flex", flexWrap:"wrap"}}>
                                {
                                    state.restrictedTypesOfGrass.length > 0 &&
                                    state.restrictedTypesOfGrass.map((grass: string, index: number)=>{
                                        for(const key of config.grassTypes){
                                            if(key === grass){
                                                return(
                                                    <div className="amenityIconBox" key={key+'-'+index}>
                                                        {/* {React.createElement(config.grassTypes[key], {style:{margin: "3px"}, color:"primary"})} */}
                                                        <span style={{margin:"0px 5px"}}>{key}</span>
                                                        <IconButton 
                                                            onClick={()=>{removeGrass(grass, "restrictedTypesOfGrass")}} 
                                                            style={{padding:"0px"}}
                                                            disabled={isLandscapingFiledDisabled('restrictedTypesOfGrass')}
                                                        >
                                                            <CloseIcon/>
                                                        </IconButton>
                                                    </div>
                                                )
                                            }
                                        }
                                    })
                                }
                                </div>
                            </>
                        }
                        <MultilineRegulationsTextArea 
                            regulationType={'grassTypeAdditionalInfo'}
                            value={state.grassTypeAdditionalInfo}
                            label="Grass Type Additional Info"
                            handleCurrentChange={handleCurrentChange}
                            disabled={isLandscapingFiledDisabled('grassTypeAdditionalInfo')}
                        />
                    </div>
                </AccordionDetails>
            </Accordion>

            <Accordion
            style={{background: expanded2 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded2(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Trees & Shrubbing
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA", flexDirection:"column"}}>
                    <FormControl style={{ margin:"12px 0px",  }} component="fieldset" variant="standard" >
                        <FormLabel component="legend">Please select the options which are restricted.</FormLabel>
                        <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.restrictedOptions.includes('Tree alteration and planting')} 
                                    onChange={(event) => 
                                        handleConnectedFieldChange(event.target.checked, 'Tree alteration and planting', 'restrictedOptions', state.regulationsOfAlterationAndPlantingOfTrees)
                                    } 
                                    disabled={isLandscapingFiledDisabled('restrictedOptions') || isLandscapingFiledDisabled('regulationsOfAlterationAndPlantingOfTrees')}
                                />
                            }
                            label="Tree alteration and planting"
                        />
                        {
                            state.restrictedOptions.includes('Tree alteration and planting') &&
                            <MultilineRegulationsTextArea 
                                regulationType={'regulationsOfAlterationAndPlantingOfTrees'}
                                value={state.regulationsOfAlterationAndPlantingOfTrees}
                                handleCurrentChange={handleCurrentChange}
                                disabled={isLandscapingFiledDisabled('regulationsOfAlterationAndPlantingOfTrees')}
                            />
                        }
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.restrictedOptions.includes('Pruning and trimming')} 
                                    onChange={(event) => 
                                        handleConnectedFieldChange(event.target.checked, 'Pruning and trimming', 'restrictedOptions', state.regulationsOfPruningTrimming)
                                    } 
                                    disabled={isLandscapingFiledDisabled('restrictedOptions') || isLandscapingFiledDisabled('regulationsOfPruningTrimming')}
                                />
                            }
                            label="Pruning and trimming"
                        />
                        {
                            state.restrictedOptions.includes('Pruning and trimming') &&
                            <MultilineRegulationsTextArea 
                                regulationType={'regulationsOfPruningTrimming'}
                                value={state.regulationsOfPruningTrimming}
                                handleCurrentChange={handleCurrentChange}
                                disabled={isLandscapingFiledDisabled('regulationsOfPruningTrimming')}
                            />
                        }
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.restrictedOptions.includes('Vegetation obstructing the view for other residents')} 
                                    onChange={(event) => 
                                        handleConnectedFieldChange(event.target.checked, 'Vegetation obstructing the view for other residents', 'restrictedOptions', state.regulationsOfVegetationObstructingResidents)
                                    } 
                                    disabled={isLandscapingFiledDisabled('restrictedOptions') || isLandscapingFiledDisabled('regulationsOfVegetationObstructingResidents')}
                                />
                            }
                            label="Vegetation obstructing the view for other residents"
                        />
                        {
                            state.restrictedOptions.includes('Vegetation obstructing the view for other residents') &&
                            <MultilineRegulationsTextArea 
                                regulationType={'regulationsOfVegetationObstructingResidents'}
                                value={state.regulationsOfVegetationObstructingResidents}
                                handleCurrentChange={handleCurrentChange}
                                disabled={isLandscapingFiledDisabled('regulationsOfVegetationObstructingResidents')}
                            />
                        }
                        </FormGroup>
                    </FormControl>
                    <div style={{ display: "flex", flexDirection: "row", marginBottom: "12px" }}>
                        <TextField style={{ width: "30%", marginRight: "20px", height: '64px' }} variant="standard" label="Height Of Canopy" value={state.canopyHeight} type='number'
                            onChange={(e) => { handleCurrentChange(e.target.value, "canopyHeight") }} onWheel={e => Wheel(e)} InputLabelProps={{ style: { fontSize: "14px" } }}
                            disabled={isLandscapingFiledDisabled('canopyHeight')}
                            InputProps={{ style: { padding: "7px 0px" } }} />
                        <Autocomplete
                            ListboxProps={{ style: { maxHeight: "200px"} }}
                            style={{ width: "25%", height:"64px", boxSizing:"border-box"}}
                            disablePortal
                            value={state.canopySize ? state.canopySize : ''}
                            options={config.canopySizes}
                            onChange={(e, v) => {
                                handleCurrentChange(v, "canopySize")
                            }}
                            disabled={isLandscapingFiledDisabled('canopySize')}
                            renderInput={(params: any) => <TextField variant="standard" style={{height:"100%"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label="Size"/>}
                        />
                    </div>
                </AccordionDetails>
            </Accordion>

            <Accordion
            style={{background: expanded3 ? "#EFF4FC" : ''}}
                onChange={(event, expanded)=>{
                    setExpanded3(expanded)
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    Soil Erosion
                </AccordionSummary>
                <AccordionDetails style={{background:"#FAFAFA"}}>
                    <FormControl style={{ margin:"12px 0px",  }} component="fieldset" variant="standard" >
                        <FormLabel component="legend">Please select the options which are mandatory to perform.</FormLabel>
                        <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.mandatoryOptions.includes('Mulch Replenishing')} 
                                    onChange={(event) => 
                                        handleConnectedFieldChange(event.target.checked, 'Mulch Replenishing', 'mandatoryOptions', state.regulationsOfMulchReplenishing)
                                    } 
                                    disabled={isLandscapingFiledDisabled('mandatoryOptions') || isLandscapingFiledDisabled('regulationsOfMulchReplenishing')}
                                />
                            }
                            label="Mulch Replenishing"
                        />
                        {
                            state.mandatoryOptions.includes('Mulch Replenishing') &&
                            <MultilineRegulationsTextArea 
                                regulationType={'regulationsOfMulchReplenishing'}
                                value={state.regulationsOfMulchReplenishing}
                                handleCurrentChange={handleCurrentChange}
                                disabled={isLandscapingFiledDisabled('regulationsOfMulchReplenishing')}
                            />
                        }
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.mandatoryOptions.includes('Irrigation maintenance and stain prevention')} 
                                    onChange={(event) => 
                                        handleConnectedFieldChange(event.target.checked, 'Irrigation maintenance and stain prevention', 'mandatoryOptions', state.regulationsOfIrrigationMaintenanceAndStainPrevention)
                                    } 
                                    disabled={isLandscapingFiledDisabled('mandatoryOptions') || isLandscapingFiledDisabled('regulationsOfIrrigationMaintenanceAndStainPrevention')}
                                />
                            }
                            label="Irrigation maintenance and stain prevention"
                        />
                        {
                            state.mandatoryOptions.includes('Irrigation maintenance and stain prevention') &&
                            <MultilineRegulationsTextArea 
                                regulationType={'regulationsOfIrrigationMaintenanceAndStainPrevention'}
                                value={state.regulationsOfIrrigationMaintenanceAndStainPrevention}
                                handleCurrentChange={handleCurrentChange}
                                disabled={isLandscapingFiledDisabled('regulationsOfIrrigationMaintenanceAndStainPrevention')}
                            />
                        }
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.mandatoryOptions.includes('Fertilization')} 
                                    onChange={(event) => 
                                        handleConnectedFieldChange(event.target.checked, 'Fertilization', 'mandatoryOptions', state.regulationsOfFertilization)
                                    } 
                                    disabled={isLandscapingFiledDisabled('mandatoryOptions') || isLandscapingFiledDisabled('regulationsOfFertilization')}
                                />
                            }
                            label="Fertilization"
                        />
                        {
                            state.mandatoryOptions.includes('Fertilization') &&
                            <MultilineRegulationsTextArea 
                                regulationType={'regulationsOfFertilization'}
                                value={state.regulationsOfFertilization}
                                handleCurrentChange={handleCurrentChange}
                                disabled={isLandscapingFiledDisabled('regulationsOfFertilization')}
                            />
                        }
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.mandatoryOptions.includes('Maintenance of Paved/Concrete Surfaces')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Maintenance of Paved/Concrete Surfaces', 'mandatoryOptions')}
                                    disabled={isLandscapingFiledDisabled('mandatoryOptions')}
                                />
                            }
                            label="Maintenance of Paved/Concrete Surfaces"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={state.mandatoryOptions.includes('Weeding')} 
                                    onChange={(event) => handleCheckBoxGroup(event.target.checked, 'Weeding', 'mandatoryOptions')}
                                    disabled={isLandscapingFiledDisabled('mandatoryOptions')}
                                />
                            }
                            label="Weeding"
                        />
                        </FormGroup>
                    </FormControl>
                </AccordionDetails>
            </Accordion>

            <EditCancelConfirmationModal 
                label="Are you sure you want to deselect? Regulation texts will be discarded if you confirm."
                isCancelClicked={isWaring}
                setIsCancelClicked={setIsWarning}
                onCancelYesClick={unCheckWarningYesClick}
            />
        </>
    )
}